<template lang="pug">
  div
    div.row
      div.col-sm-12.col-xl-12
        payment-datatable(ref="datatable" @payment-clicked="onPaymentClicked")

    payment-form-modal(ref="paymentFormModal" :payment="payment")
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import PaymentDatatable from './settings-payment-restore-datatable.vue';
import PaymentFormModal from './settings-payment-form-modal.vue';
import PaymentTypeFilter from './settings-payment-type-filter.vue';

export default {
    components: {
        PaymentDatatable,
        PaymentFormModal,
        PaymentTypeFilter,
    },

    data() {
        return {
            payment: null,
        };
    },

    computed: {
        ...mapState('payment', ['filterOutlets']),

        localFilterOutlets: {
            get() {
                return this.filterOutlets;
            },

            set(value) {
                this.setFilterOutlets(value);
            },
        },
    },

    methods: {
        ...mapMutations('payment', ['setFilterOutlets']),

        onPaymentClicked(payment) {
            this.$refs.paymentFormModal.showForm(payment);
        },

        refresh() {
            this.$refs.datatable.refresh();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/settings-payment-restore.vue